import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Menu } from "antd";

import {
  ABOUT_US,
  CAR_PARK_LIST,
  HOME_PAGE,
  NEWS,
  SERVICE,
  AWARDS,
  HOW_IT_WORKS,
  PROFILE,
} from "settings/constant";
import { useTranslation } from "react-i18next";

const MainMenu = ({
  className,
  showCarpark,
  showService,
  showNews,
  showAbout,
  showAwards,
  showFAQ,
  showHOW,
}) => {
  const { t } = useTranslation();

  const { state } = useLocation();

  return (
    <Menu className={className}>
      <Menu.Item key={HOME_PAGE}>
        <NavLink exact to={HOME_PAGE}>
          {t("navbar.home")}
        </NavLink>
      </Menu.Item>
      {showCarpark && (
        <Menu.Item key={CAR_PARK_LIST}>
          <NavLink to={`${CAR_PARK_LIST}`}>{t("navbar.listing")}</NavLink>
        </Menu.Item>
      )}
      {showService && (
        <Menu.Item key={SERVICE}>
          <NavLink exact to={`${SERVICE}`}>
            {t("navbar.service")}
          </NavLink>
        </Menu.Item>
      )}
      {showNews && (
        <Menu.Item key={NEWS}>
          <NavLink exact to={`${NEWS}`}>
            {t("navbar.news")}
          </NavLink>
        </Menu.Item>
      )}
      {showAbout && (
        <Menu.Item key={ABOUT_US}>
          <NavLink exact to={`${ABOUT_US}`}>
            {t("navbar.about")}
          </NavLink>
        </Menu.Item>
      )}
      {showAwards && (
        <Menu.Item key={AWARDS}>
          <NavLink exact to={`${AWARDS}`}>
            {t("navbar.awards")}
          </NavLink>
        </Menu.Item>
      )}
      {showFAQ && (
        <Menu.Item key={HOW_IT_WORKS}>
          <NavLink exact to={`${HOW_IT_WORKS}`}>
            {t("navbar.faq")}
          </NavLink>
        </Menu.Item>
      )}
      {showHOW && (
        <Menu.Item key="HomeHow">
          <NavLink
            activeClassName={state?.scrollTo === "how" ? "active" : "noAcitve"}
            exact
            to={{
              pathname: HOME_PAGE,
              state: { scrollTo: "how" },
            }}
          >
            {t("navbar.how")}
          </NavLink>
        </Menu.Item>
      )}
    </Menu>
  );
};

export default MainMenu;
